<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" right="iconfenxiang" @rightClick="onShare" />
    <van-tabs v-model="activeTab" @change="onTabChange">
      <van-tab title="入口信息">
        <div v-if="data" class="baseRect">
          <div class="title">{{ data.exam.title }} 考试入口二维码</div>
          <div class="qrCodeArea">
            <van-image
              width="60vw"
              height="60vw"
              :src="qrCodeSrc"
              :style="data.countDownTime<=0?'opacity:0.3;filter:alpha(opacity=30);':''"
              @click="onShare"
            />
          </div>
          <div class="timeLimitArea">
            <b>有效期:</b>{{ formatDate(data.begin.beginTime,"MM/dd hh:mm",true) }} - {{ formatDate(data.begin.endTime,"MM/dd hh:mm",true) }}
            <span v-if="data.countDownTime>0"><b>剩余:</b><van-count-down style="display: inline;" :time="data.countDownTime" /></span>
            <van-tag v-if="data.countDownTime<=0" round type="danger">已结束</van-tag>
          </div>
          <div class="aboutRect">
            备注:<br>
            1.请扫码二维码或者点击分享链接进入考试系统;<br>
            2.请在限制时间内进入，超时无法进入;<br>
            3.本次考试由<b @click="onTestEnter">{{ data.coachName }}</b>负责;<br>
            4.本次测验<b v-if="data.begin.isJustStudent" :style="'color:'+GetColorMainBack()">仅限行程/课程顾客参加</b><b v-if="!data.begin.isJustStudent" :style="'color:'+GetColorMainBack()">任何人可参加</b>;<br>
            5.测验结束后，学员可以查看错题回顾。
          </div>

          <div v-if="data.countDownTime>0" class="downButton">
            <van-row gutter="10">
              <van-col span="12"><van-button type="warning" :loading="buttonLoading" :color="GetColorSecondary()" class="button" @click="onFinishExamBegin">结束测验</van-button></van-col>
              <van-col span="12"><van-button type="primary" :loading="buttonLoading" :color="GetColorMainBack()" class="button" @click="onAddExamBeginTime">延长20分钟</van-button></van-col>
            </van-row>
          </div>
        </div>
      </van-tab>
      <van-tab title="参与用户">
        <van-skeleton title avatar :row="3" :loading="examUserListLoading">
          <div v-for="item in examUserList" :key="item.examResultId" class="userRect">
            <div class="headIcon">
              <van-image
                width="3em"
                height="4em"
                fit="cover"
                radius="0.4em"
                lazy-load
                :src="item.userIcon?item.userIcon:'/img/defaultUserIcon.jpg'"
              />
            </div>
            <div class="bodys">
              <van-row>
                <van-col span="14"><span>开始时间:</span> {{ formatDate(item.beginTime,"yyyy/MM/dd hh:mm",true) }}</van-col>
                <van-col span="10"><span>结果:</span>
                  <van-tag v-if="!item.finishTime" text-color="#fff" color="#999">进行中</van-tag>
                  <van-tag v-if="item.finishTime && item.isPass" text-color="#fff" type="success">通过</van-tag>
                  <van-tag v-if="item.finishTime && !item.isPass" text-color="#fff" type="danger">未通过</van-tag>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="14"><span>耗时:</span> {{ item.totalSecond }}s</van-col>
                <van-col span="10"><span>得分:</span> {{ (item.myScore*100/item.totalScore) }}分</van-col>
              </van-row>
              <van-row>
                <van-col span="14"><span>用户:</span> {{ item.userId }}</van-col>
                <van-col span="10"><span>生日:</span> {{ formatDate(item.birthday,"yyyy/MM/dd") }}</van-col>
              </van-row>
              <van-row>
                <van-col span="14"><span>昵称:</span> {{ item.userNickName }}</van-col>
                <van-col span="10"><span>姓名:</span> {{ item.userLastName }} {{ item.userFirstName }}</van-col>
              </van-row>

            </div>
          </div>
        </van-skeleton>
      </van-tab>
      <van-tab title="成绩分析">
        <!-- <fullError title="暂未开放" about="正在施工中,敬请期待" native-str="" background-color="#f5f5f5" /> -->
        <van-skeleton title avatar :row="6" :loading="examAnalysisListLoading">
          <div v-for="(item,index) in examAnalysisList" :key="index" class="QuestionRect">
            <van-tag v-if="item.totalErrorPerson>0" class="tags" type="danger">{{ item.totalErrorPerson }}人错</van-tag>
            <div class="question" style="display: inline-block;" v-html="item.questionBody" />

            <template v-if="item.question.answer0">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('0')>=0?'color:#0a0':''" v-html="item.question.answer0" />
              <van-tag v-for="(name,nameIndex) in item.errorList.A.errorList" :key="'A'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer1">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('1')>=0?'color:#0a0':''" v-html="item.question.answer1" />
              <van-tag v-for="(name,nameIndex) in item.errorList.B.errorList" :key="'B'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer2">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('2')>=0?'color:#0a0':''" v-html="item.question.answer2" />
              <van-tag v-for="(name,nameIndex) in item.errorList.C.errorList" :key="'C'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer3">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('3')>=0?'color:#0a0':''" v-html="item.question.answer3" />
              <van-tag v-for="(name,nameIndex) in item.errorList.D.errorList" :key="'D'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer4">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('4')>=0?'color:#0a0':''" v-html="item.question.answer4" />
              <van-tag v-for="(name,nameIndex) in item.errorList.E.errorList" :key="'E'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer5">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('5')>=0?'color:#0a0':''" v-html="item.question.answer5" />
              <van-tag v-for="(name,nameIndex) in item.errorList.F.errorList" :key="'F'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer6">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('6')>=0?'color:#0a0':''" v-html="item.question.answer6" />
              <van-tag v-for="(name,nameIndex) in item.errorList.G.errorList" :key="'G'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>
            <template v-if="item.question.answer7">
              <br>
              <div style="display: inline-block;" :style="item.question.trueAnswer.indexOf('7')>=0?'color:#0a0':''" v-html="item.question.answer7" />
              <van-tag v-for="(name,nameIndex) in item.errorList.H.errorList" :key="'H'+index+nameIndex" class="tags" type="warning">{{ name }}</van-tag>
            </template>

          </div>
        </van-skeleton>
      </van-tab>
    </van-tabs>
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Tab, Tabs, CountDown, Tag, Image, Skeleton, Lazyload, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { GetServiceUrl, GetSelfUrl } from '@/utils/request'
import { MyNotify, getUrlKey, UrlBase64, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
export default {
  components: {
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [CountDown.name]: CountDown,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Skeleton.name]: Skeleton,
    [Lazyload.name]: Lazyload,
    [Dialog.name]: Dialog,
    TopBar,
    wxShare
  },
  data() {
    return {
      titleTop: '',
      title: '测验管理',
      backurl: '/pro/examList',
      activeTab: 0,
      examBeginid: undefined,
      data: undefined,
      qrCodeSrc: undefined,
      system: undefined,
      showShare: false,
      urlEnter: '',
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      examUserList: [],
      examUserListLoading: false,
      buttonLoading: false,
      examAnalysisList: [],
      examAnalysisListLoading: true
    }
  },

  created() {
    this.system = getUrlKey('system')
    this.titleTop = GetSysTitle()
    this.examBeginid = this.$route.params.id
    this.init()
  },
  methods: {
    UrlBase64,
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onShareFinish() {
      this.shareUrl = undefined
    },
    init(callback) {
      request({
        url: '/DiveLearn/getExamBegin',
        method: 'post',
        params: {
          id: this.examBeginid
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.exam.title + '入口'
        this.urlEnter = GetSelfUrl() + 'divetrip/exam?hashCode=' + this.data.begin.hashCode + '&system=' + this.system
        const Base64 = require('js-base64').Base64
        this.qrCodeSrc = GetServiceUrl() + 'image/qr?data=' + Base64.encode(this.urlEnter)
        if (callback) {
          callback()
        }
      })
    },
    onTestEnter() {
      this.$router.push('/divetrip/exam?hashCode=' + this.data.begin.hashCode)
    },
    onShare() {
      if (!this.data) {
        return
      }
      if (this.data.countDownTime <= 0) {
        MyNotify('info', '考试已结束', 2000)
        return
      }
      this.showShare = true
      this.shareTitle = this.data.coachName + '邀请您参加“' + this.data.exam.title + '”考试'
      this.shareAbout = this.data.coachName + '邀请您参加“' + this.data.exam.title + '”考试'
      this.shareTimeline = this.data.coachName + '邀请您参加“' + this.data.exam.title + '”考试'
      this.shareUrl = undefined
      this.shareUrl = this.urlEnter
      this.shareIcon = GetSelfUrl() + 'img/picShare.jpg'
    },
    onTabChange(index) {
      if (index === 1) {
        this.loadExamUserList()
      }
      if (index === 2) {
        this.loadExamAnalysisList()
      }
    },
    loadExamUserList() {
      this.examUserList = []
      this.examUserListLoading = true
      request({
        url: '/DiveLearn/getExamResultList',
        method: 'post',
        params: {
          id: this.examBeginid
        }
      }).then(response => {
        this.examUserListLoading = false
        if (!response.success) {
          return
        }
        this.examUserList = response.data
      })
    },
    loadExamAnalysisList() {
      this.examAnalysisList = []
      this.examAnalysisListLoading = true
      request({
        url: '/DiveLearn/getExamAnalysisList',
        method: 'post',
        params: {
          id: this.examBeginid
        }
      }).then(response => {
        this.examAnalysisListLoading = false
        if (!response.success) {
          return
        }
        this.examAnalysisList = response.data
        this.examAnalysisList.forEach(el => {
          el.questionBody = el.id + '.' + el.question.question
          el.question.answer0 = el.question.answer0 ? 'A.' + el.question.answer0 : ''
          el.question.answer1 = el.question.answer1 ? 'B.' + el.question.answer1 : ''
          el.question.answer2 = el.question.answer2 ? 'C.' + el.question.answer2 : ''
          el.question.answer3 = el.question.answer3 ? 'D.' + el.question.answer3 : ''
          el.question.answer4 = el.question.answer4 ? 'E.' + el.question.answer4 : ''
          el.question.answer5 = el.question.answer5 ? 'F.' + el.question.answer5 : ''
          el.question.answer6 = el.question.answer6 ? 'G.' + el.question.answer6 : ''
          el.question.answer7 = el.question.answer7 ? 'H.' + el.question.answer7 : ''
        })
      })
    },
    onAddExamBeginTime() {
      this.buttonLoading = true
      request({
        url: '/DiveLearn/addExamBeginTime',
        method: 'post',
        params: {
          id: this.examBeginid
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.init()
        MyNotify('success', '已延长测验入口有效期20分钟', 2000)
      })
    },
    onFinishExamBegin() {
      Dialog.confirm({
        title: '结束测试入口',
        message: '提前结束测试，在测试中的任然可以进行，已完成学员可以查看错题回顾',
        cancelButtonText: '取消',
        confirmButtonText: '结束'
      }).then(() => {
        this.onFinishExamDo()
      })
    },
    onFinishExamDo() {
      this.buttonLoading = true
      request({
        url: '/DiveLearn/finishExamBegin',
        method: 'post',
        params: {
          id: this.examBeginid
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        this.init()
      })
      MyNotify('success', '已结束测验', 2000)
    }
  }
}
</script>
<style scoped>
.baseRect{
  background-color: #fff;
  padding: 1em;
}
.baseRect .title{
  text-align: center;
  font-weight: 700;
  padding: 1em 0 ;

}
.baseRect  .qrCodeArea{
  text-align: center;
}
.baseRect  .timeLimitArea{
  text-align: center;
  font-size: 0.8em;
}
.baseRect .aboutRect{
  font-size: 0.8em;
  color: #999;
  margin-top: 2em;
  line-height: 1.8em;
}

.userRect{
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  padding: 0.5em 1em;
}
.userRect .headIcon{
  position: absolute;
  left: 1em;
  top: 0.5em;
}
.userRect .bodys{
  margin-left: 4.5em;
  font-size: 0.8em;
  min-height: 5em;
}
.userRect .bodys span{
  color: #999;
}
.downButton{
  margin-top: 1em;
}
.downButton .button{
  width: 100%;
}
.QuestionRect{
  background-color: #fff;
  padding: 1em;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 1em;
  font-size: 0.8em;
}
.QuestionRect .question{
  font-weight: 700;
  margin-bottom: 0.5em;
}
.QuestionRect .tags{
  margin-left: 0.5em;
}
</style>
